/**
 * Trims a search term and collapses internal runs of whitespace.
 *
 * Not for the API's benefit — it tokenizes anyway, and `"  cat  swap  "`
 * returns exactly the same results as `"cat swap"`. This exists for the two
 * places where the raw string is used as an identity:
 *
 * - **Recent searches.** `addRecentSearch` de-duplicates case-insensitively
 *   but not whitespace-insensitively, so `"cat "` and `"cat"` would both
 *   persist and show as two identical-looking rows. A trailing space before
 *   tapping Search is a common mobile habit.
 * - **The React Query key.** `['search', term]` would otherwise cache
 *   the same search twice and fetch it twice.
 */
const formatSearchKeyword = (keyword: string): string =>
  keyword.trim().replace(/\s+/g, ' ');

export default formatSearchKeyword;
